import { connect } from 'react-redux';
import { closeDrawer } from 'actions/drawer';
import { DRAWER_ADD_MEMBERS } from 'types/drawer';
import  { actions } from '@amplement/backend-connector';

import Drawer from './index';

const mapStateToProps = (state) => ({
    initialValues: {
        _feed: state.drawer[DRAWER_ADD_MEMBERS]?._feed
    }
});

const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(closeDrawer(DRAWER_ADD_MEMBERS)),
    onSubmit: ({ _members, _feed }) => {
        if (_feed && _members?.length) {
            const _targets = _members?.map(x => x.value);
            dispatch(actions.members.inviteMemberIntoFeed(_feed, _targets));
        }
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);
